import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
export const NotFound = () => {
  return <div className="py-24 lg:py-32 bg-white min-h-[calc(100vh-300px)] flex items-center" data-id="element-834">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12 text-center" data-id="element-835">
        <div className="w-20 h-20 bg-gray50 rounded-full flex items-center justify-center mx-auto mb-8 border border-gray200" data-id="element-836">
          <AlertCircle className="w-8 h-8 text-brandRed" data-id="element-837" />
        </div>
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-4" data-id="element-838">
          Page Not Found
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-839">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="inline-flex items-center gap-2 bg-brandRed hover:bg-brandRedDark text-white font-bold py-3.5 px-8 rounded-sm transition-colors text-base" data-id="element-840">
          <ArrowLeft className="w-5 h-5" data-id="element-841" />
          Return to Homepage
        </Link>
      </div>
    </div>;
};